import React from "react"
import { getPhrase } from "../../shared/translation"

export function Loading({ showLabel }: { showLabel?: boolean }) {
    return (
        <div className="loading">
            <div className="sk-chase mb-1">
                <div className="sk-chase-dot" />
                <div className="sk-chase-dot" />
                <div className="sk-chase-dot" />
                <div className="sk-chase-dot" />
                <div className="sk-chase-dot" />
                <div className="sk-chase-dot" />
            </div>
            {showLabel && <span>{getPhrase("Loading")}</span>}
        </div>
    )
}